import adminApiClient from './api.admin';
class AdminAuthService {
    async login(credentials) {
        return adminApiClient.post('/api/auth/login', credentials);
    }
    async logout() {
        // Si el backend tiene endpoint de logout, usarlo aquí
        return Promise.resolve({ success: true });
    }
    async checkToken(token) {
        // Si el backend tiene endpoint para verificar token, usarlo aquí
        return Promise.resolve({ valid: true });
    }
}
export const adminAuthService = new AdminAuthService();
export default adminAuthService;
